<template>
  <div>
    <v-btn
      class="mx-2"
      v-for="transition in transitions"
      v-bind:data="transition"
      v-bind:key="transition.id"
      :disabled="isDisabled(transition.requiresValidContent)"
      @click="save(transition.to)"
      light
    >
    {{ transition.label }}
    </v-btn>
  </div>
</template>
<script>
export default {
  props: {
    workflow: String, // Workflow of the content type
    status: String, // Current status
    save: Function,
    contentValid: Boolean // To check if all content is validated
  },
  data: function () {
    return {
      transitions: []
    }
  },
  methods: {
    isDisabled: function (requiresValidContent) {
   
      if (requiresValidContent) {
        return !this.contentValid
      }
    
      return false
    }
  },
  mounted: function () {
    // Check every transition


    this.$store.state.workflows[this.workflow].transitions.forEach((transition) => {
      // If there is a transition for the current status
      if (transition.from.includes(this.status)) {
        this.transitions.push(transition)
      }
    })
      
  }
 
}
</script>
